import {onBeforeUnmount, watch} from 'vue';

export function useRefDom({ target, cleanup, onChange }) {
  let dom;

  const stopWatch = watch(
    () => target.value,
    el => {
      cleanup(dom);

      dom = el;
      onChange(dom);
    },
    { immediate: true, flush: 'post' },
  );

  function stop() {
    cleanup(dom);
    stopWatch();
  }

  onBeforeUnmount(() => {
    stop();
  });

  return {
    stop,
  };
}
